import { UserPermissions } from '../../../types/shared/User';

export const AccessLevelList = {
  NONE: { description: 'No Access' },
  READ: { description: 'Read-only' },
  WRITE: { description: 'Modify' },
};

// Could not get it working like below without the as statement
// export const ACCESS_LEVELS: Array<AccessLevel> = Object.keys(AccessLevelList);
export const ACCESS_LEVELS = Object.keys(AccessLevelList);

export const DEFAULT_USER_PERMISSIONS: UserPermissions = {
  users: 'READ',
  vendors: 'WRITE',
  billing: 'WRITE',
  metrics: 'WRITE',
  attendance: 'WRITE',
  formBuilder: 'WRITE',
  marketsAndPricing: 'WRITE',
  marketSales: 'WRITE',
  marketPages: 'WRITE',
  vendorPlacement: 'WRITE',
  settings: 'WRITE',
};

export type AccessLevel = keyof typeof AccessLevelList;
export type AccountPermissionKeys = keyof UserPermissions;
